import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';


const initialState = {
    data: [],
    isLoading: false,
    officeCode: '',
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchCP90DefectiveMetersStats = createAsyncThunk(
    'dashboard/fetchCP90DefectiveMeters',
    async ({ token, officeCode }) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("officeCode", officeCode);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `dashBoard/defectiveMetersCP90Summary`, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'monthlyATC issue!');
        }

        const result = await response.json();

        if (result.status !== "200") {
            throw new Error(result.message || 'Unable to fetch stats!');
        }

        return result;
    }
);

const cp90DefectiveMeters = createSlice({
    name: 'cp90DefectiveMeters',
    initialState: initialState,
    reducers: {
        resetState(state) {
            state.data = [];
            state.officeCode = '';
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCP90DefectiveMetersStats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCP90DefectiveMetersStats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload.data;
            })
            .addCase(fetchCP90DefectiveMetersStats.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetState } = cp90DefectiveMeters.actions;

export default cp90DefectiveMeters.reducer;
